export const careTimelineTooltip =
  'Care Timeline provides a chronological list of post to guide you along the caregiver journey. ' +
  'As you proceed, new posts appear at the top.'

export const trainingTimelineTooltip =
  'Training Timeline provides a chronological list of posts to guide you along the caregiver journey. ' +
  'As you proceed, new posts appear at the top.'

export const traineeMyTeamsTooltip =
  'My Teams brings together the people who care for and support you and those you care for. ' +
  'Complete profiles to contact them easily.'

export const myTeamsTooltip =
  'My Teams brings together the people who care for and support your Person of Concern. ' +
  'Send an email through the app to form your team. ' +
  'Add additional people by clicking on the "Invite" button in the My Teams tab.'
